
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1334Dialog extends Serenity.EntityDialog<Report_1334Row, any> {
        protected getFormKey() { return Report_1334Form.formKey; }
        protected getIdProperty() { return Report_1334Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1334Row.localTextPrefix; }
        protected getNameProperty() { return Report_1334Row.nameProperty; }
        protected getService() { return Report_1334Service.baseUrl; }
        protected getDeletePermission() { return Report_1334Row.deletePermission; }
        protected getInsertPermission() { return Report_1334Row.insertPermission; }
        protected getUpdatePermission() { return Report_1334Row.updatePermission; }

        protected form = new Report_1334Form(this.idPrefix);

    }
}